import { render, staticRenderFns } from "./update-day-wage.vue?vue&type=template&id=be75b8e4&scoped=true"
import script from "./update-day-wage.vue?vue&type=script&lang=js"
export * from "./update-day-wage.vue?vue&type=script&lang=js"
import style0 from "./update-day-wage.vue?vue&type=style&index=0&id=be75b8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be75b8e4",
  null
  
)

export default component.exports